export class TransactionFilter{
    public walletType : string;
    public transactionDateStart: Date;
    public transactionDateEnd: Date;
    public type: number;
    public hash: string;
}


// WEBPACK FOOTER //
// ./src/app/core/models/transactionFilter.model.ts